<template>
  <div>
    <b-modal  @hide="hide" id="addModal" size="xl" title="Yeni Hazır Cevap Ekle" hide-footer>
      <b-form @submit="onSubmit" >

        <div class="row">
          <div class="col-md-12">
            <b-form-group label="İçerik">
              <b-textarea v-model="text" required></b-textarea>
            </b-form-group>
          </div>

        </div>
        <hr>
        <div class="row">

        </div>
        <div class="d-flex justify-content-center" v-if="!loading">
          <b-button type="submit" variant="success" class=""> <i class="fas fa-check" /> Kaydet</b-button>
        </div>
        <div class="d-flex justify-content-center" v-if="loading">
          <b-button type="submit" variant="success" class="" disabled> <span>  <i class="fas fa-spinner fa-spin"></i></span> </b-button>
        </div>
      </b-form>




    </b-modal>
  </div>
</template>

<script>
import bankAccountsService from "@/services/bankAccountsService";

export default {
  name: "CreateAnswer",
  data() {
    return {
      loading: false,
      text: '',
    }
  },
  methods: {
    hide() {
      this.text = ''
    },
    onSubmit(event) {
      event.preventDefault()
      this.loading = true
      bankAccountsService.addAnswer({
        text: this.text,
      })
          .then((res) => {
            this.loading = false
            if(res.state){
              this.$store.dispatch('getNotifyMessage', {siteConfirm: true, show: true, icon: 'success', title: 'Başarıyla Eklendi', message: ''})
              this.$bvModal.hide('addModal')
              this.$store.dispatch('getRefresh', true)
            }else{
              this.$store.dispatch('getConfirmMessage', {show: true, icon: 'error', title: 'Ops!', message: res.message})
            }
          })
    },
  }
}
</script>

<style scoped>

</style>